import { NgModel, FormControlName, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, HostListener, Renderer2, Optional, Self } from '@angular/core';

@Directive({
  selector: '[appTrim]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TrimDirective,
      multi: true,
    },
  ],
})
export class TrimDirective implements ControlValueAccessor {
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    @Optional() @Self() private ngModel: NgModel,
    @Optional() @Self() private formControlName: FormControlName
  ) {}

  @HostListener('blur')
  onBlur() {
    let value: string = this.elementRef.nativeElement.value;

    if (value) {
      value = value.trim();
      this.updateValue(value);
    } else {
      this.updateValue('');
    }
  }

  // ControlValueAccessor methods for Reactive Forms
  writeValue(value: any): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  private onChange: any = () => {};
  private onTouched: any = () => {};

  private updateValue(value: string) {
    // Update the native element
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
    this.renderer.setAttribute(this.elementRef.nativeElement, 'value', value);

    // For template-driven forms
    if (this.ngModel) {
      this.ngModel.update.emit(value);
    }

    // For reactive forms
    if (this.formControlName && this.formControlName.control) {
      this.formControlName.control.setValue(value);
    }

    // Call the change callback for reactive forms
    if (this.onChange) {
      this.onChange(value);
    }

    // Call the touched callback
    if (this.onTouched) {
      this.onTouched();
    }
  }
}
